import React from 'react';
export function TrustSection() {
  const certifications = [{
    src: 'https://cdn.magicpatterns.com/uploads/dNexntwFHMkm7ZPkJVXEbM/iso-9001-certified.jpg',
    alt: 'ISO 9001',
    label: 'ISO 9001'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gpDeLGDsven44JSBqjzPBx/ISO_14001.jpg',
    alt: 'ISO 14001',
    label: 'ISO 14001'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/osdWtkSKVjaRAt7iCy6kEa/Joscar.png',
    alt: 'JOSCAR',
    label: 'JOSCAR'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6FuydEZynCq18cGM9hgcSz/Cyber.jpg',
    alt: 'Cyber Essentials',
    label: 'Cyber Essentials'
  }];
  return <section className="py-6 bg-slate-50 border-y border-slate-100" data-id="element-518">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-519">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-520">
          {/* Trust Text - Reduced weight */}
          <p className="text-base font-semibold text-slate-600 flex flex-wrap justify-center md:justify-start items-center gap-4" data-id="element-521">
            <span className="flex items-center gap-2" data-id="element-522">
              <span className="text-xl" data-id="element-523">🇬🇧</span>
              UK manufactured
            </span>
            <span className="text-slate-300 hidden md:inline" data-id="element-524">•</span>
            <span data-id="element-525">Quality assured</span>
          </p>

          {/* Certification Logos - Increased size by ~20% */}
          <div className="flex flex-wrap justify-center items-center gap-6" data-id="element-526">
            {certifications.map((cert, index) => <div key={index} className="flex flex-col items-center gap-2" data-id="element-527">
                <div className="h-[68px] w-24 bg-white rounded-lg flex items-center justify-center p-2.5 border border-slate-150" data-id="element-528">
                  <img src={cert.src} alt={cert.alt} className="max-w-full max-h-full object-contain" data-id="element-529" />
                </div>
                <span className="text-[11px] font-medium text-slate-400 text-center" data-id="element-530">
                  {cert.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}